import { Tabs, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import TabPane from "antd/es/tabs/TabPane";
import ProductMain from "./product-main";
import ProductPacket from "./product-packet";
import { useState } from "react";
import { isMobile } from "../../../extensions/design";

const tabsConfig = [
  { key: "1", label: "Общее" },
  { key: "2", label: "Пакет" },
];

const Product = ({ id, onClose, onRefresh, barcode, name }) => {
  const [vid, setVid] = useState();
  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (key) => {
    if (key === "2" && vid !== 2 && vid !== 3) return;
    setActiveTab(key);
  };

  const renderContent = () => {
    switch (activeTab) {
      case "1": return <ProductMain id={id} onClose={onClose} onRefresh={onRefresh} barcode={barcode} setVid={setVid}/>;
      case "2": return <ProductPacket id={id} onClose={onClose}/>;
      default: return null;
    }
  };

  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className={isMobile ? "sport-modal-content mobile-content" : "sport-modal-content"} style={isMobile ? {} : {width: 800}}>
        <div className={isMobile ? "sport-modal-title-client" : "client-modal-title"}>
          <span style={{fontSize: "14px"}}>Номенклатура</span>
          {isMobile && (
            <Select className="mobile-tabs-select" value={activeTab} onChange={handleTabChange} style={{ width: "58%", marginRight: "0px" }}>
              {tabsConfig.map(({ key, label }) => (
                <Select.Option key={key} value={key} disabled={key === "2" && vid !== 2 && vid !== 3}>
                  {label}
                </Select.Option>
              ))}
            </Select>
          )}
          <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9, marginLeft: "auto", cursor: "pointer" }}/>
          {isMobile ? <div className="client-name">{name}</div> : <></>}
        </div>

        {isMobile ? (
          <div className="product-mobile-content">{renderContent()}</div>
        ) : (
          <div className="custom-tabs-container">
            <Tabs type="card" className="custom-tabs" activeKey={activeTab} onChange={handleTabChange}>
              <TabPane tab="Общее" key="1">
                <ProductMain id={id} onClose={onClose} onRefresh={onRefresh} barcode={barcode} setVid={setVid}/>
              </TabPane>
              <TabPane tab="Пакет" key="2" disabled={vid !== 2 && vid !== 3}>
                <ProductPacket id={id} onClose={onClose}/>
              </TabPane>
            </Tabs>
          </div>
        )}
      </div>
    </div>
  </div>
}

export default Product;
